import { createReducer } from 'Helpers/redux'
import {
  GET_ALL_LANGUAGES,
  GET_LANGUAGES_FOR_EXISTING_PLAYLISTS,
} from '../actions/languagesActions'

const initialState = {
  languages: [],
  existing_playlists_languages: [],
}

const handlers = {
  [GET_ALL_LANGUAGES.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    languages: payload,
  }),

  [GET_LANGUAGES_FOR_EXISTING_PLAYLISTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    existing_playlists_languages: payload,
  }),
}

export default createReducer(initialState, handlers)
